import React from "react";
import "./App.css";
import { DataContextProvider } from "./data-context/DataContextProvider";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest, apiTokenRequest } from "./auth/authConfig";
import TokenExpirationHandler from "./auth/TokenExpirationHandler";
import Header from "./components/header/Header";
import DayPlanParent from "./components/day-plan/DayPlanParent";
import HttpInterceptor from "./api/HttpInterceptor";
import { ErrorBoundary } from "@preppa/shared-ui";
import ApiErrorToast from "./components/notifications/ApiErrorToast";

function AppContent() {
  return (
    <>
      <HttpInterceptor />
      <TokenExpirationHandler apiTokenRequest={apiTokenRequest} />
      <Header />
      <DayPlanParent />
      <ApiErrorToast />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={loginRequest}
        >
          <DataContextProvider>
            <AppContent />
          </DataContextProvider>
        </MsalAuthenticationTemplate>
      </div>
    </ErrorBoundary>
  );
}

export default App;
